module.exports = __webpack_public_path__ + "static/media/Frovo for Businesses.d8e1d348.png";